module.exports = __webpack_public_path__ + "img/61.3f27eb12.jpg";